import React, { Component } from "react";
import Singleproject from "./components/singleproject";
import Allprojects from "./components/allprojects";
import Nav from "./components/nav";
import About from "./components/about";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import "./App.css";
import { Route, Switch } from "react-router-dom";
import { push } from "react-router-redux";

class App extends Component {
  shouldComponentUpdate(nextProp, nextState) {
    return this.props.location.pathname !== nextProp.location.pathname;
  }

  handleClick() {
    this.props.push("/projects");
  }

  render() {
    return (
      <div className="App">
        <Nav pathname={this.props.location.pathname} />
        <Switch>
          <Route exact path="/project/:proj" component={Singleproject} />
          <Route exact path="/about" component={About} />
          <Route exact path="/:filter" component={Allprojects} />
          <Route path="/" component={Allprojects} />
        </Switch>
        <div id="footer" className="desktop-only">
          © 2022 Melissa Wei
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    current: state.current,
    projects: state.projects,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
    },
    dispatch
  );
};

const ConnectedApp = connect(mapStateToProps, mapDispatchToProps)(App);

export default ConnectedApp;



// WEBPACK FOOTER //
// ./src/App.js